import template from './operation-type.html';
import controller from './operation-type.controller';

let operationTypeComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default operationTypeComponent;
